import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from "../context/LanguageProvider";
import { isSupportedBrowser } from '../utils/supportedBrowser';
import '../style/browserSupportBanner.css';

/**
 * Renders a fixed red bar at the top of the page when the current browser is not
 * one of the supported browsers (Google Chrome / Microsoft Edge).
 *
 * The browser can't change during a page's lifetime, so this is computed once.
 */
function BrowserSupportBanner() {
  const { t } = useTranslation();
  const { dir } = useLanguage();
  const [supported] = useState(() => isSupportedBrowser());

  if (supported) return null;

  return (
    <div className="browser-support-banner" role="alert" style={{ direction: dir }}>
      {t('browserSupport.unsupported', {
        defaultValue:
          'This browser is not supported. Please use Google Chrome or Microsoft Edge instead.',
      })}
    </div>
  );
}

export default BrowserSupportBanner;
